import * as Illustration from "@npco/zeller-design-system/illustration";

export namespace Signature {
	export type Props = {
		signature: string | undefined;
	};
}

/**
 * The terminal sends the signature as dark ink on a transparent background, so
 * it needs a light backing to stay legible. The plate is unconditional rather
 * than a `dark:` utility because those only apply once the design system's
 * `zds-mode-*` class is on `<html>`, which the SPA sets only when a host passes
 * `theme` in the request query.
 */
export function Signature({ signature }: Signature.Props) {
	return signature ? (
		<img
			alt="customer signature"
			className="bg-white rounded-8 p-8 w-[180px] h-[180px]"
			src={signature}
		/>
	) : (
		<Illustration.TerminalT2Signature loop={false} />
	);
}
